import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreService } from '../../services/store.service';

@Component({
    selector: 'app-module-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    standalone: false
})
export class SearchModuleComponent implements OnInit {
  @Input() term: string = '';
  public termSearch: string = '';
  private subscription: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public storeService: StoreService
  ) { }

  ngOnInit(): void {
    if(this.term != '') {
      this.termSearch = this.term;
      this.goToSearch();
    }
  }

  goToSearch() {
    if(this.termSearch != '') {
      this.router.navigate([`search/${this.termSearch}`]);
      this.storeService.searchAuthoritiesCollection(this.termSearch,1,1);
    }
  }

}
